import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Report, ReportService } from "@core/data";
import { Select, Store } from "@ngxs/store";
import { Observable, Subject } from "rxjs";
import { InitReportShareHistory, ReportShareHistoryState, ReportShareHistoryStateModel } from "./report-share-history.dialog.state";

export interface ReportShareHistoryDialogData {
    report: Report;
}

@Component({
    selector: 'pv-report-share-history-dialog',
    templateUrl: 'report-share-history.dialog.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./report-share-history.dialog.scss']
})
export class ReportShareHistoryDialog implements OnInit, OnDestroy {

    @Select(ReportShareHistoryState)
    state$: Observable<ReportShareHistoryStateModel>;

    private _destroy$ = new Subject();

    constructor(
        private _store: Store,
        private _reportService: ReportService,
        @Inject(MAT_DIALOG_DATA) private _data: ReportShareHistoryDialogData,
        private _ref: MatDialogRef<ReportShareHistoryDialog>,
    ) {}

    ngOnInit(): void {
        this._store.dispatch(new InitReportShareHistory(this._data.report));
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }
}